function Footer(): JSX.Element {
  return (
    <footer className="website-footer p-4">
      <p className="text-center">In qualità di Affiliati Amazon riceviamo un guadagno per ciascun acquisto idoneo.</p>
    </footer>
  );
}

export default Footer;